export interface SnackBarModel {
  message: string;
  duration?: number;
  type: AlertType;
  withCloseIcon?: boolean;
}

export enum AlertType {
  info = "info",
  error = "error",
  warn = "warn",
  success = "success",
}
